var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMobileAppDevelopment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mobile_app_development",
    "data-name": "mobile app development",
    transform: "translate(-659 -181)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19",
    "data-name": "Rectangle 19",
    width: 32,
    height: 32,
    transform: "translate(659 181)",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "weather",
    transform: "translate(565 182)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_151",
    "data-name": "Path 151",
    d: "M116.76,0h-2.21V2a1.516,1.516,0,0,1-1.513,1.515h-5.96A1.515,1.515,0,0,1,105.565,2V0h-2.216A2.352,2.352,0,0,0,101,2.349V27.56a2.352,2.352,0,0,0,2.349,2.349H116.76a2.351,2.351,0,0,0,2.349-2.349V2.349A2.351,2.351,0,0,0,116.76,0Zm-4.305,27.578H107.66a.876.876,0,0,1,0-1.752h4.795a.876.876,0,0,1,0,1.752Zm2.292-11.749h-.723a4.045,4.045,0,0,1-.543,1.313l.516.518a.876.876,0,0,1-1.241,1.237l-.511-.513a4.032,4.032,0,0,1-1.31.547v.73a.876.876,0,1,1-1.752,0v-.728a4.022,4.022,0,0,1-1.309-.543l-.51.511a.876.876,0,0,1-1.241-1.237l.512-.513a4.059,4.059,0,0,1-.546-1.318h-.724a.876.876,0,0,1,0-1.752h.723a4.057,4.057,0,0,1,.547-1.32l-.515-.516a.876.876,0,1,1,1.241-1.237l.512.513a4.025,4.025,0,0,1,1.307-.543v-.729a.876.876,0,1,1,1.752,0v.729a4.01,4.01,0,0,1,1.309.545l.515-.516A.876.876,0,1,1,114,12.243l-.518.519h0a4.046,4.046,0,0,1,.545,1.315h.724a.876.876,0,1,1,0,1.752Z",
    transform: "translate(0)",
    fill: "#e76d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_152",
    "data-name": "Path 152",
    d: "M209.15,0h5.48V1.758h-5.48Z",
    transform: "translate(-101.832 0)",
    fill: "#e76d27"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_153",
    "data-name": "Path 153",
    d: "M218.76,216.27a2.321,2.321,0,1,0,2.311,2.321A2.318,2.318,0,0,0,218.76,216.27Z",
    transform: "translate(-108.706 -203.636)",
    fill: "#e76d27"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileAppDevelopment);
export default __webpack_public_path__ + "static/media/mobile_app_development.0d536690cb309dd6a11fd7afcea66cdc.svg";
export { ForwardRef as ReactComponent };